import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-basket",
  "use": "icon-basket-usage",
  "viewBox": "0 0 242 226",
  "content": "<symbol viewBox=\"0 0 242 226\" id=\"icon-basket\">\r\n<g>\r\n\t<path d=\"M242,105.5V15.1H60.5C60.5,6.8,53.7,0,45.4,0H0v15.1h30.3l11.4,97c-6.9,5.5-11.4,14-11.4,23.5c0,16.6,13.5,30.1,30.2,30.1\r\n\t\tH242v-15.1H60.5c-8.3,0-15.1-6.7-15.1-15.1c0,0,0-0.1,0-0.2L242,105.5z\" />\r\n\t<path d=\"M219.3,180.8c-12.5,0-22.7,10.1-22.7,22.6s10.2,22.6,22.7,22.6s22.7-10.1,22.7-22.6C242,190.9,231.8,180.8,219.3,180.8z\" />\r\n\t<path d=\"M68.1,180.8c-12.5,0-22.7,10.1-22.7,22.6S55.6,226,68.1,226s22.7-10.1,22.7-22.6C90.8,190.9,80.6,180.8,68.1,180.8z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/general/svg/basket.svg
// module id = iwUV
// module chunks = 0